// src/pages/Referral.jsx
import { useState } from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { C } from '../styles/tokens';

const REFERRALS = [
  { name:'James Okonkwo',  date:'Jan 12, 2025', status:'Verified', reward:'+50 ONT' },
  { name:'Sofia Martinez', date:'Jan 8, 2025',  status:'Verified', reward:'+50 ONT' },
  { name:'Kai Nakamura',   date:'Jan 3, 2025',  status:'Pending',  reward:'Pending' },
  { name:'Amara Diallo',   date:'Dec 28, 2024', status:'Verified', reward:'+50 ONT' },
];

const statusColor = { Verified:C.success, Pending:C.warning };

export default function Referral() {
  const [copied, setCopied] = useState(false);
  const code = 'NEXUS-AJ8472';
  const link = `https://oraclenexus.io/join?ref=${code}`;

  return (
    <DashboardLayout title="Referral Program" subtitle="Invite friends and earn 50 ONT for every verified signup">
      <style>{`
        .referral-stats {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
          margin-bottom: 20px;
        }
        .referral-layout {
          display: grid;
          grid-template-columns: 1fr 340px;
          gap: 20px;
        }
        .share-btns {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }
        .share-btns button { flex: 1; min-width: 100px; }
        @media (max-width: 900px) {
          .referral-layout { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 600px) {
          .referral-stats { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 380px) {
          .referral-stats { grid-template-columns: 1fr !important; }
          .share-btns { flex-direction: column !important; }
          .share-btns button { min-width: unset !important; }
        }
      `}</style>

      {/* Stats */}
      <div className="referral-stats">
        {[['🎯','Total Referrals','4',C.magenta],['✅','Verified','3',C.success],['🪙','ONT Earned','150',C.warning],['⏳','Pending','1',C.info]].map(([i,l,v,c]) => (
          <div key={l} className="card" style={{ padding:'18px 20px' }}>
            <div style={{ position:'absolute', top:0, left:0, right:0, height:2, background:`linear-gradient(90deg,${c}70,transparent)` }} />
            <span style={{ fontSize:22 }}>{i}</span>
            <div className="syne" style={{ fontSize:'clamp(20px,4vw,26px)', fontWeight:800, color:c, marginTop:8 }}>{v}</div>
            <div style={{ fontSize:12, color:'rgba(255,255,255,.5)', fontWeight:600 }}>{l}</div>
          </div>
        ))}
      </div>

      <div className="referral-layout">
        {/* Left */}
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {/* Referral code card */}
          <div className="card" style={{ padding:'clamp(20px,4vw,28px)', background:`linear-gradient(135deg,${C.navy}60,${C.violet}30)` }}>
            <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg,${C.magenta},${C.violet})` }} />
            <h3 className="syne" style={{ fontSize:17, fontWeight:700, marginBottom:6 }}>Your Referral Code</h3>
            <p style={{ fontSize:13, color:'rgba(255,255,255,.45)', marginBottom:20 }}>Share your code or link. Earn 50 ONT for every friend who registers and completes KYC.</p>

            {/* Code box */}
            <div style={{ padding:'14px 18px', background:'rgba(0,0,0,.3)', borderRadius:11, border:'1px solid rgba(254,52,232,.25)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, marginBottom:14, flexWrap:'wrap' }}>
              <span className="syne" style={{ fontSize:'clamp(18px,4vw,22px)', fontWeight:800, color:C.magenta, letterSpacing:'.08em' }}>{code}</span>
              <button onClick={() => { setCopied(true); navigator.clipboard?.writeText(code); setTimeout(() => setCopied(false), 2000); }} style={{ padding:'8px 14px', background: copied ? 'rgba(0,208,132,.2)' : 'rgba(255,255,255,.1)', border:'none', borderRadius:7, color: copied ? C.success : 'white', cursor:'pointer', fontSize:12, fontWeight:700, transition:'all .2s', flexShrink:0 }}>{copied ? '✓ Copied' : 'Copy'}</button>
            </div>

            {/* Link box */}
            <div style={{ padding:'10px 14px', background:'rgba(255,255,255,.04)', borderRadius:10, border:'1px solid rgba(255,255,255,.08)', display:'flex', alignItems:'center', gap:10, marginBottom:18 }}>
              <span style={{ fontSize:12, color:'rgba(255,255,255,.45)', fontFamily:'monospace', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1, minWidth:0 }}>{link}</span>
              <button onClick={() => navigator.clipboard?.writeText(link)} style={{ padding:'6px 12px', background:'rgba(255,255,255,.08)', border:'none', borderRadius:7, color:'white', cursor:'pointer', fontSize:11, fontWeight:600, flexShrink:0 }}>Copy</button>
            </div>

            {/* Share buttons */}
            <div className="share-btns">
              {[['𝕏 Share on X', C.electric || '#1DA1F2'],['in LinkedIn','#0077b5'],['📱 SMS',C.success]].map(([l,c]) => (
                <button key={l} style={{ padding:'10px 8px', background:`${c}15`, border:`1px solid ${c}30`, borderRadius:9, color:'#fff', fontSize:'clamp(11px,2vw,12px)', fontWeight:600, cursor:'pointer' }}>{l}</button>
              ))}
            </div>
          </div>

          {/* Referral list */}
          <div className="card" style={{ padding:'clamp(18px,3vw,24px)' }}>
            <h3 className="syne" style={{ fontSize:16, fontWeight:700, marginBottom:16 }}>Your Referrals</h3>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {REFERRALS.map((r, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', borderRadius:11, background:'rgba(255,255,255,.025)', border:'1px solid rgba(255,255,255,.06)', flexWrap:'wrap' }}>
                  <div style={{ width:38, height:38, borderRadius:'50%', background:`linear-gradient(135deg,${C.magenta},${C.violet})`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:700, fontFamily:"'Syne',sans-serif", flexShrink:0 }}>{r.name.charAt(0)}</div>
                  <div style={{ flex:1, minWidth:120 }}>
                    <div style={{ fontSize:14, fontWeight:600 }}>{r.name}</div>
                    <div style={{ fontSize:11, color:'rgba(255,255,255,.38)', marginTop:1 }}>Joined {r.date}</div>
                  </div>
                  <span style={{ fontSize:11, padding:'3px 10px', borderRadius:100, background:`${statusColor[r.status]}15`, color:statusColor[r.status], fontWeight:700 }}>{r.status}</span>
                  <span style={{ fontSize:13, fontWeight:700, color: r.reward==='Pending' ? C.warning : C.success, fontFamily:"'Syne',sans-serif" }}>{r.reward}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right: how it works */}
        <div className="card" style={{ padding:'clamp(18px,3vw,24px)', alignSelf:'start' }}>
          <h3 className="syne" style={{ fontSize:16, fontWeight:700, marginBottom:18 }}>How It Works</h3>
          {[
            { n:'01', i:'🔗', t:'Share Your Link',  d:'Copy your unique referral link or code and share with friends, colleagues, or on social media.' },
            { n:'02', i:'📝', t:'Friend Signs Up',   d:'Your friend registers using your code or link and creates a verified Oracle Nexus account.' },
            { n:'03', i:'🪪', t:'KYC Verified',      d:'Once they complete KYC verification and profile setup, the referral is confirmed.' },
            { n:'04', i:'🪙', t:'You Earn 50 ONT',   d:'Tokens are instantly credited to your wallet. No limits — refer as many as you want!' },
          ].map((s, i) => (
            <div key={i} style={{ display:'flex', gap:12, marginBottom:18 }}>
              <div style={{ width:36, height:36, borderRadius:9, background:`linear-gradient(135deg,${C.magenta}20,${C.violet}20)`, border:`1px solid rgba(254,52,232,.2)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, flexShrink:0 }}>{s.i}</div>
              <div>
                <div style={{ display:'flex', gap:6, alignItems:'center', marginBottom:4 }}>
                  <span style={{ fontSize:10, color:C.magenta, fontWeight:800 }}>{s.n}</span>
                  <span className="syne" style={{ fontSize:14, fontWeight:700 }}>{s.t}</span>
                </div>
                <p style={{ fontSize:12.5, color:'rgba(255,255,255,.45)', lineHeight:1.6 }}>{s.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
